// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "permit.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "permit.proto" (syntax proto3)
// tslint:disable
import { Empty } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf enum PermitListKind
 */
export var PermitListKind;
(function (PermitListKind) {
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_UNSPECIFIED = 0;
     */
    PermitListKind[PermitListKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_BLOCKER = 1;
     */
    PermitListKind[PermitListKind["BLOCKER"] = 1] = "BLOCKER";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_NEXT_ACTION = 2;
     */
    PermitListKind[PermitListKind["NEXT_ACTION"] = 2] = "NEXT_ACTION";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_JURISDICTION = 3;
     */
    PermitListKind[PermitListKind["JURISDICTION"] = 3] = "JURISDICTION";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_INSPECTION_TYPE = 4;
     */
    PermitListKind[PermitListKind["INSPECTION_TYPE"] = 4] = "INSPECTION_TYPE";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_INSPECTION_PATH = 5;
     */
    PermitListKind[PermitListKind["INSPECTION_PATH"] = 5] = "INSPECTION_PATH";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_INSPECTION_METHOD = 6;
     */
    PermitListKind[PermitListKind["INSPECTION_METHOD"] = 6] = "INSPECTION_METHOD";
    /**
     * @generated from protobuf enum value: PERMIT_LIST_KIND_DOCUMENT_TYPE = 7;
     */
    PermitListKind[PermitListKind["DOCUMENT_TYPE"] = 7] = "DOCUMENT_TYPE";
})(PermitListKind || (PermitListKind = {}));
// @generated message type with reflection information, may provide speed optimized methods
class PermitGroup$Type extends MessageType {
    constructor() {
        super("PermitGroup", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "requestor_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "po", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "assigned_user", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "plan_grid", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "on_behalf", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "permits", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Permit },
            { no: 14, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "not_equals", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "permit_group_documents", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitGroupDocument },
            { no: 22, name: "internal_notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "scope_of_work", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "valuation", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 25, name: "search_trades", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "search_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "next_action_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 28, name: "next_action_note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 29, name: "next_action_due", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 30, name: "backup_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 31, name: "jurisdiction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 32, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 33, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.requestorId = 0;
        message.po = "";
        message.startDate = "";
        message.endDate = "";
        message.assignedUser = 0;
        message.createdDate = "";
        message.planGrid = false;
        message.onBehalf = false;
        message.isActive = false;
        message.fieldMask = [];
        message.permits = [];
        message.dateRange = [];
        message.dateTarget = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.notEquals = [];
        message.permitGroupDocuments = [];
        message.internalNotes = "";
        message.scopeOfWork = "";
        message.valuation = 0;
        message.searchTrades = "";
        message.searchStatus = "";
        message.nextActionId = 0;
        message.nextActionNote = "";
        message.nextActionDue = "";
        message.backupUserId = 0;
        message.jurisdictionId = 0;
        message.propertyId = 0;
        message.updatedAt = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 requestor_id */ 2:
                    message.requestorId = reader.int32();
                    break;
                case /* string po */ 3:
                    message.po = reader.string();
                    break;
                case /* string start_date */ 4:
                    message.startDate = reader.string();
                    break;
                case /* string end_date */ 5:
                    message.endDate = reader.string();
                    break;
                case /* int32 assigned_user */ 6:
                    message.assignedUser = reader.int32();
                    break;
                case /* string created_date */ 7:
                    message.createdDate = reader.string();
                    break;
                case /* bool plan_grid */ 8:
                    message.planGrid = reader.bool();
                    break;
                case /* bool on_behalf */ 9:
                    message.onBehalf = reader.bool();
                    break;
                case /* bool is_active */ 10:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 12:
                    message.fieldMask.push(reader.string());
                    break;
                case /* repeated Permit permits */ 13:
                    message.permits.push(Permit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string date_range */ 14:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 15:
                    message.dateTarget.push(reader.string());
                    break;
                case /* string order_by */ 16:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 17:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 18:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 19:
                    message.withoutLimit = reader.bool();
                    break;
                case /* repeated string not_equals */ 20:
                    message.notEquals.push(reader.string());
                    break;
                case /* repeated PermitGroupDocument permit_group_documents */ 21:
                    message.permitGroupDocuments.push(PermitGroupDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string internal_notes */ 22:
                    message.internalNotes = reader.string();
                    break;
                case /* string scope_of_work */ 23:
                    message.scopeOfWork = reader.string();
                    break;
                case /* float valuation */ 24:
                    message.valuation = reader.float();
                    break;
                case /* string search_trades */ 25:
                    message.searchTrades = reader.string();
                    break;
                case /* string search_status */ 26:
                    message.searchStatus = reader.string();
                    break;
                case /* int32 next_action_id */ 27:
                    message.nextActionId = reader.int32();
                    break;
                case /* string next_action_note */ 28:
                    message.nextActionNote = reader.string();
                    break;
                case /* string next_action_due */ 29:
                    message.nextActionDue = reader.string();
                    break;
                case /* int32 backup_user_id */ 30:
                    message.backupUserId = reader.int32();
                    break;
                case /* int32 jurisdiction_id */ 31:
                    message.jurisdictionId = reader.int32();
                    break;
                case /* int32 property_id */ 32:
                    message.propertyId = reader.int32();
                    break;
                case /* string updated_at */ 33:
                    message.updatedAt = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 requestor_id = 2; */
        if (message.requestorId !== 0)
            writer.tag(2, WireType.Varint).int32(message.requestorId);
        /* string po = 3; */
        if (message.po !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.po);
        /* string start_date = 4; */
        if (message.startDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.startDate);
        /* string end_date = 5; */
        if (message.endDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.endDate);
        /* int32 assigned_user = 6; */
        if (message.assignedUser !== 0)
            writer.tag(6, WireType.Varint).int32(message.assignedUser);
        /* string created_date = 7; */
        if (message.createdDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.createdDate);
        /* bool plan_grid = 8; */
        if (message.planGrid !== false)
            writer.tag(8, WireType.Varint).bool(message.planGrid);
        /* bool on_behalf = 9; */
        if (message.onBehalf !== false)
            writer.tag(9, WireType.Varint).bool(message.onBehalf);
        /* bool is_active = 10; */
        if (message.isActive !== false)
            writer.tag(10, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 12; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* repeated Permit permits = 13; */
        for (let i = 0; i < message.permits.length; i++)
            Permit.internalBinaryWrite(message.permits[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated string date_range = 14; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 15; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string order_by = 16; */
        if (message.orderBy !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 17; */
        if (message.orderDir !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 18; */
        if (message.pageNumber !== 0)
            writer.tag(18, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 19; */
        if (message.withoutLimit !== false)
            writer.tag(19, WireType.Varint).bool(message.withoutLimit);
        /* repeated string not_equals = 20; */
        for (let i = 0; i < message.notEquals.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.notEquals[i]);
        /* repeated PermitGroupDocument permit_group_documents = 21; */
        for (let i = 0; i < message.permitGroupDocuments.length; i++)
            PermitGroupDocument.internalBinaryWrite(message.permitGroupDocuments[i], writer.tag(21, WireType.LengthDelimited).fork(), options).join();
        /* string internal_notes = 22; */
        if (message.internalNotes !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.internalNotes);
        /* string scope_of_work = 23; */
        if (message.scopeOfWork !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.scopeOfWork);
        /* float valuation = 24; */
        if (message.valuation !== 0)
            writer.tag(24, WireType.Bit32).float(message.valuation);
        /* string search_trades = 25; */
        if (message.searchTrades !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.searchTrades);
        /* string search_status = 26; */
        if (message.searchStatus !== "")
            writer.tag(26, WireType.LengthDelimited).string(message.searchStatus);
        /* int32 next_action_id = 27; */
        if (message.nextActionId !== 0)
            writer.tag(27, WireType.Varint).int32(message.nextActionId);
        /* string next_action_note = 28; */
        if (message.nextActionNote !== "")
            writer.tag(28, WireType.LengthDelimited).string(message.nextActionNote);
        /* string next_action_due = 29; */
        if (message.nextActionDue !== "")
            writer.tag(29, WireType.LengthDelimited).string(message.nextActionDue);
        /* int32 backup_user_id = 30; */
        if (message.backupUserId !== 0)
            writer.tag(30, WireType.Varint).int32(message.backupUserId);
        /* int32 jurisdiction_id = 31; */
        if (message.jurisdictionId !== 0)
            writer.tag(31, WireType.Varint).int32(message.jurisdictionId);
        /* int32 property_id = 32; */
        if (message.propertyId !== 0)
            writer.tag(32, WireType.Varint).int32(message.propertyId);
        /* string updated_at = 33; */
        if (message.updatedAt !== "")
            writer.tag(33, WireType.LengthDelimited).string(message.updatedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitGroup
 */
export const PermitGroup = new PermitGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitGroupList$Type extends MessageType {
    constructor() {
        super("PermitGroupList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitGroup },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitGroup results */ 1:
                    message.results.push(PermitGroup.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitGroup results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitGroup.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitGroupList
 */
export const PermitGroupList = new PermitGroupList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Permit$Type extends MessageType {
    constructor() {
        super("Permit", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "permit_group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "trade_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "status_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "inspections", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Inspection },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "permit_documents", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitDocument },
            { no: 16, name: "jurisdiction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "permit_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "issued_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "expiration_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 21, name: "department_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "blockers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitListItem },
            { no: 23, name: "updated_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "status_changed_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "application_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.permitGroupId = 0;
        message.jobNumber = 0;
        message.tradeId = 0;
        message.statusId = 0;
        message.statusDescription = "";
        message.notes = "";
        message.isActive = false;
        message.fieldMask = [];
        message.inspections = [];
        message.orderBy = "";
        message.orderDir = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.permitDocuments = [];
        message.jurisdictionId = 0;
        message.permitNumber = "";
        message.issuedDate = "";
        message.expirationDate = "";
        message.departmentId = 0;
        message.departmentDescription = "";
        message.blockers = [];
        message.updatedAt = "";
        message.statusChangedAt = "";
        message.applicationNumber = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 permit_group_id */ 2:
                    message.permitGroupId = reader.int32();
                    break;
                case /* int32 job_number */ 3:
                    message.jobNumber = reader.int32();
                    break;
                case /* int32 trade_id */ 4:
                    message.tradeId = reader.int32();
                    break;
                case /* int32 status_id */ 5:
                    message.statusId = reader.int32();
                    break;
                case /* string status_description */ 6:
                    message.statusDescription = reader.string();
                    break;
                case /* string notes */ 7:
                    message.notes = reader.string();
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* repeated Inspection inspections */ 10:
                    message.inspections.push(Inspection.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* int32 page_number */ 13:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 14:
                    message.withoutLimit = reader.bool();
                    break;
                case /* repeated PermitDocument permit_documents */ 15:
                    message.permitDocuments.push(PermitDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 jurisdiction_id */ 16:
                    message.jurisdictionId = reader.int32();
                    break;
                case /* string permit_number */ 17:
                    message.permitNumber = reader.string();
                    break;
                case /* string issued_date */ 18:
                    message.issuedDate = reader.string();
                    break;
                case /* string expiration_date */ 19:
                    message.expirationDate = reader.string();
                    break;
                case /* int32 department_id */ 20:
                    message.departmentId = reader.int32();
                    break;
                case /* string department_description */ 21:
                    message.departmentDescription = reader.string();
                    break;
                case /* repeated PermitListItem blockers */ 22:
                    message.blockers.push(PermitListItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string updated_at */ 23:
                    message.updatedAt = reader.string();
                    break;
                case /* string status_changed_at */ 24:
                    message.statusChangedAt = reader.string();
                    break;
                case /* string application_number */ 25:
                    message.applicationNumber = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 permit_group_id = 2; */
        if (message.permitGroupId !== 0)
            writer.tag(2, WireType.Varint).int32(message.permitGroupId);
        /* int32 job_number = 3; */
        if (message.jobNumber !== 0)
            writer.tag(3, WireType.Varint).int32(message.jobNumber);
        /* int32 trade_id = 4; */
        if (message.tradeId !== 0)
            writer.tag(4, WireType.Varint).int32(message.tradeId);
        /* int32 status_id = 5; */
        if (message.statusId !== 0)
            writer.tag(5, WireType.Varint).int32(message.statusId);
        /* string status_description = 6; */
        if (message.statusDescription !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.statusDescription);
        /* string notes = 7; */
        if (message.notes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.notes);
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* repeated Inspection inspections = 10; */
        for (let i = 0; i < message.inspections.length; i++)
            Inspection.internalBinaryWrite(message.inspections[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* int32 page_number = 13; */
        if (message.pageNumber !== 0)
            writer.tag(13, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 14; */
        if (message.withoutLimit !== false)
            writer.tag(14, WireType.Varint).bool(message.withoutLimit);
        /* repeated PermitDocument permit_documents = 15; */
        for (let i = 0; i < message.permitDocuments.length; i++)
            PermitDocument.internalBinaryWrite(message.permitDocuments[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* int32 jurisdiction_id = 16; */
        if (message.jurisdictionId !== 0)
            writer.tag(16, WireType.Varint).int32(message.jurisdictionId);
        /* string permit_number = 17; */
        if (message.permitNumber !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.permitNumber);
        /* string issued_date = 18; */
        if (message.issuedDate !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.issuedDate);
        /* string expiration_date = 19; */
        if (message.expirationDate !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.expirationDate);
        /* int32 department_id = 20; */
        if (message.departmentId !== 0)
            writer.tag(20, WireType.Varint).int32(message.departmentId);
        /* string department_description = 21; */
        if (message.departmentDescription !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.departmentDescription);
        /* repeated PermitListItem blockers = 22; */
        for (let i = 0; i < message.blockers.length; i++)
            PermitListItem.internalBinaryWrite(message.blockers[i], writer.tag(22, WireType.LengthDelimited).fork(), options).join();
        /* string updated_at = 23; */
        if (message.updatedAt !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.updatedAt);
        /* string status_changed_at = 24; */
        if (message.statusChangedAt !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.statusChangedAt);
        /* string application_number = 25; */
        if (message.applicationNumber !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.applicationNumber);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Permit
 */
export const Permit = new Permit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitList$Type extends MessageType {
    constructor() {
        super("PermitList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Permit },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Permit results */ 1:
                    message.results.push(Permit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Permit results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Permit.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitList
 */
export const PermitList = new PermitList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Inspection$Type extends MessageType {
    constructor() {
        super("Inspection", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "status_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "requestor_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "creator_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "requestor_scheduled_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "scheduled_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "inspection_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "inspection_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "inspection_path_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "inspection_method_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "inspection_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "onsite_contact_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "onsite_contact_phone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "confirmation_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "inspection_path_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "inspection_method_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.permitId = 0;
        message.notes = "";
        message.statusId = 0;
        message.statusDescription = "";
        message.fieldMask = [];
        message.requestorId = 0;
        message.creatorId = 0;
        message.requestorScheduledDate = "";
        message.scheduledDate = "";
        message.inspectionType = "";
        message.inspectionTypeId = 0;
        message.inspectionPathId = 0;
        message.inspectionMethodId = 0;
        message.inspectionTypeName = "";
        message.onsiteContactName = "";
        message.onsiteContactPhone = "";
        message.confirmationNumber = "";
        message.inspectionPathName = "";
        message.inspectionMethodName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 permit_id */ 2:
                    message.permitId = reader.int32();
                    break;
                case /* string notes */ 3:
                    message.notes = reader.string();
                    break;
                case /* int32 status_id */ 4:
                    message.statusId = reader.int32();
                    break;
                case /* string status_description */ 5:
                    message.statusDescription = reader.string();
                    break;
                case /* repeated string field_mask */ 6:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 requestor_id */ 7:
                    message.requestorId = reader.int32();
                    break;
                case /* int32 creator_id */ 8:
                    message.creatorId = reader.int32();
                    break;
                case /* string requestor_scheduled_date */ 9:
                    message.requestorScheduledDate = reader.string();
                    break;
                case /* string scheduled_date */ 10:
                    message.scheduledDate = reader.string();
                    break;
                case /* string inspection_type */ 11:
                    message.inspectionType = reader.string();
                    break;
                case /* int32 inspection_type_id */ 12:
                    message.inspectionTypeId = reader.int32();
                    break;
                case /* int32 inspection_path_id */ 13:
                    message.inspectionPathId = reader.int32();
                    break;
                case /* int32 inspection_method_id */ 14:
                    message.inspectionMethodId = reader.int32();
                    break;
                case /* string inspection_type_name */ 15:
                    message.inspectionTypeName = reader.string();
                    break;
                case /* string onsite_contact_name */ 16:
                    message.onsiteContactName = reader.string();
                    break;
                case /* string onsite_contact_phone */ 17:
                    message.onsiteContactPhone = reader.string();
                    break;
                case /* string confirmation_number */ 18:
                    message.confirmationNumber = reader.string();
                    break;
                case /* string inspection_path_name */ 19:
                    message.inspectionPathName = reader.string();
                    break;
                case /* string inspection_method_name */ 20:
                    message.inspectionMethodName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 permit_id = 2; */
        if (message.permitId !== 0)
            writer.tag(2, WireType.Varint).int32(message.permitId);
        /* string notes = 3; */
        if (message.notes !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.notes);
        /* int32 status_id = 4; */
        if (message.statusId !== 0)
            writer.tag(4, WireType.Varint).int32(message.statusId);
        /* string status_description = 5; */
        if (message.statusDescription !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.statusDescription);
        /* repeated string field_mask = 6; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 requestor_id = 7; */
        if (message.requestorId !== 0)
            writer.tag(7, WireType.Varint).int32(message.requestorId);
        /* int32 creator_id = 8; */
        if (message.creatorId !== 0)
            writer.tag(8, WireType.Varint).int32(message.creatorId);
        /* string requestor_scheduled_date = 9; */
        if (message.requestorScheduledDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.requestorScheduledDate);
        /* string scheduled_date = 10; */
        if (message.scheduledDate !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.scheduledDate);
        /* string inspection_type = 11; */
        if (message.inspectionType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.inspectionType);
        /* int32 inspection_type_id = 12; */
        if (message.inspectionTypeId !== 0)
            writer.tag(12, WireType.Varint).int32(message.inspectionTypeId);
        /* int32 inspection_path_id = 13; */
        if (message.inspectionPathId !== 0)
            writer.tag(13, WireType.Varint).int32(message.inspectionPathId);
        /* int32 inspection_method_id = 14; */
        if (message.inspectionMethodId !== 0)
            writer.tag(14, WireType.Varint).int32(message.inspectionMethodId);
        /* string inspection_type_name = 15; */
        if (message.inspectionTypeName !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.inspectionTypeName);
        /* string onsite_contact_name = 16; */
        if (message.onsiteContactName !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.onsiteContactName);
        /* string onsite_contact_phone = 17; */
        if (message.onsiteContactPhone !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.onsiteContactPhone);
        /* string confirmation_number = 18; */
        if (message.confirmationNumber !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.confirmationNumber);
        /* string inspection_path_name = 19; */
        if (message.inspectionPathName !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.inspectionPathName);
        /* string inspection_method_name = 20; */
        if (message.inspectionMethodName !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.inspectionMethodName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Inspection
 */
export const Inspection = new Inspection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InspectionList$Type extends MessageType {
    constructor() {
        super("InspectionList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Inspection },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated Inspection results */ 1:
                    message.results.push(Inspection.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated Inspection results = 1; */
        for (let i = 0; i < message.results.length; i++)
            Inspection.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InspectionList
 */
export const InspectionList = new InspectionList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitStatus$Type extends MessageType {
    constructor() {
        super("PermitStatus", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.description = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string code */ 3:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string code = 3; */
        if (message.code !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitStatus
 */
export const PermitStatus = new PermitStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitStatusList$Type extends MessageType {
    constructor() {
        super("PermitStatusList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitStatus },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitStatus results */ 1:
                    message.results.push(PermitStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitStatus results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitStatus.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitStatusList
 */
export const PermitStatusList = new PermitStatusList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InspectionStatus$Type extends MessageType {
    constructor() {
        super("InspectionStatus", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.description = "";
        message.code = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string code */ 3:
                    message.code = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string code = 3; */
        if (message.code !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.code);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InspectionStatus
 */
export const InspectionStatus = new InspectionStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InspectionStatusList$Type extends MessageType {
    constructor() {
        super("InspectionStatusList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InspectionStatus },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated InspectionStatus results */ 1:
                    message.results.push(InspectionStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated InspectionStatus results = 1; */
        for (let i = 0; i < message.results.length; i++)
            InspectionStatus.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InspectionStatusList
 */
export const InspectionStatusList = new InspectionStatusList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitTrade$Type extends MessageType {
    constructor() {
        super("PermitTrade", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.isActive = false;
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* bool is_active */ 3:
                    message.isActive = reader.bool();
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* bool is_active = 3; */
        if (message.isActive !== false)
            writer.tag(3, WireType.Varint).bool(message.isActive);
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitTrade
 */
export const PermitTrade = new PermitTrade$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitTradeList$Type extends MessageType {
    constructor() {
        super("PermitTradeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitTrade },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitTrade results */ 1:
                    message.results.push(PermitTrade.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitTrade results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitTrade.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitTradeList
 */
export const PermitTradeList = new PermitTradeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitDocument$Type extends MessageType {
    constructor() {
        super("PermitDocument", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "document_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "document_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.permitId = 0;
        message.fileId = 0;
        message.fileName = "";
        message.fileBucket = "";
        message.mimeType = "";
        message.fieldMask = [];
        message.documentTypeId = 0;
        message.documentTypeName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 permit_id */ 2:
                    message.permitId = reader.int32();
                    break;
                case /* int32 file_id */ 3:
                    message.fileId = reader.int32();
                    break;
                case /* string file_name */ 4:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 5:
                    message.fileBucket = reader.string();
                    break;
                case /* string mime_type */ 6:
                    message.mimeType = reader.string();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 document_type_id */ 8:
                    message.documentTypeId = reader.int32();
                    break;
                case /* string document_type_name */ 9:
                    message.documentTypeName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 permit_id = 2; */
        if (message.permitId !== 0)
            writer.tag(2, WireType.Varint).int32(message.permitId);
        /* int32 file_id = 3; */
        if (message.fileId !== 0)
            writer.tag(3, WireType.Varint).int32(message.fileId);
        /* string file_name = 4; */
        if (message.fileName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 5; */
        if (message.fileBucket !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fileBucket);
        /* string mime_type = 6; */
        if (message.mimeType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mimeType);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 document_type_id = 8; */
        if (message.documentTypeId !== 0)
            writer.tag(8, WireType.Varint).int32(message.documentTypeId);
        /* string document_type_name = 9; */
        if (message.documentTypeName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.documentTypeName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitDocument
 */
export const PermitDocument = new PermitDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitDocumentList$Type extends MessageType {
    constructor() {
        super("PermitDocumentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitDocument },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitDocument results */ 1:
                    message.results.push(PermitDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitDocument results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitDocument.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitDocumentList
 */
export const PermitDocumentList = new PermitDocumentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitGroupDocument$Type extends MessageType {
    constructor() {
        super("PermitGroupDocument", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "permit_group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "file_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "file_bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.permitGroupId = 0;
        message.fileId = 0;
        message.fileName = "";
        message.fileBucket = "";
        message.mimeType = "";
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 permit_group_id */ 2:
                    message.permitGroupId = reader.int32();
                    break;
                case /* int32 file_id */ 3:
                    message.fileId = reader.int32();
                    break;
                case /* string file_name */ 4:
                    message.fileName = reader.string();
                    break;
                case /* string file_bucket */ 5:
                    message.fileBucket = reader.string();
                    break;
                case /* string mime_type */ 6:
                    message.mimeType = reader.string();
                    break;
                case /* repeated string field_mask */ 7:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 permit_group_id = 2; */
        if (message.permitGroupId !== 0)
            writer.tag(2, WireType.Varint).int32(message.permitGroupId);
        /* int32 file_id = 3; */
        if (message.fileId !== 0)
            writer.tag(3, WireType.Varint).int32(message.fileId);
        /* string file_name = 4; */
        if (message.fileName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.fileName);
        /* string file_bucket = 5; */
        if (message.fileBucket !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.fileBucket);
        /* string mime_type = 6; */
        if (message.mimeType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mimeType);
        /* repeated string field_mask = 7; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitGroupDocument
 */
export const PermitGroupDocument = new PermitGroupDocument$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitGroupDocumentList$Type extends MessageType {
    constructor() {
        super("PermitGroupDocumentList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitGroupDocument },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitGroupDocument results */ 1:
                    message.results.push(PermitGroupDocument.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitGroupDocument results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitGroupDocument.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitGroupDocumentList
 */
export const PermitGroupDocumentList = new PermitGroupDocumentList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitListItem$Type extends MessageType {
    constructor() {
        super("PermitListItem", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "kind", kind: "enum", T: () => ["PermitListKind", PermitListKind, "PERMIT_LIST_KIND_"] },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "usage_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.kind = 0;
        message.name = "";
        message.sortOrder = 0;
        message.isActive = false;
        message.usageCount = 0;
        message.code = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* PermitListKind kind */ 2:
                    message.kind = reader.int32();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* int32 sort_order */ 4:
                    message.sortOrder = reader.int32();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* int32 usage_count */ 6:
                    message.usageCount = reader.int32();
                    break;
                case /* string code */ 7:
                    message.code = reader.string();
                    break;
                case /* repeated string field_mask */ 8:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 9:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 10:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 11:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 12:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* PermitListKind kind = 2; */
        if (message.kind !== 0)
            writer.tag(2, WireType.Varint).int32(message.kind);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* int32 sort_order = 4; */
        if (message.sortOrder !== 0)
            writer.tag(4, WireType.Varint).int32(message.sortOrder);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* int32 usage_count = 6; */
        if (message.usageCount !== 0)
            writer.tag(6, WireType.Varint).int32(message.usageCount);
        /* string code = 7; */
        if (message.code !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.code);
        /* repeated string field_mask = 8; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 9; */
        if (message.pageNumber !== 0)
            writer.tag(9, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 10; */
        if (message.orderBy !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 11; */
        if (message.orderDir !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 12; */
        if (message.withoutLimit !== false)
            writer.tag(12, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitListItem
 */
export const PermitListItem = new PermitListItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitListItemList$Type extends MessageType {
    constructor() {
        super("PermitListItemList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitListItem },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitListItem results */ 1:
                    message.results.push(PermitListItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitListItem results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitListItem.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitListItemList
 */
export const PermitListItemList = new PermitListItemList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitListReorderRequest$Type extends MessageType {
    constructor() {
        super("PermitListReorderRequest", [
            { no: 1, name: "kind", kind: "enum", T: () => ["PermitListKind", PermitListKind, "PERMIT_LIST_KIND_"] },
            { no: 2, name: "ordered_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.orderedIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* PermitListKind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* repeated int32 ordered_ids */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.orderedIds.push(reader.int32());
                    else
                        message.orderedIds.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* PermitListKind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* repeated int32 ordered_ids = 2; */
        if (message.orderedIds.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.orderedIds.length; i++)
                writer.int32(message.orderedIds[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitListReorderRequest
 */
export const PermitListReorderRequest = new PermitListReorderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitListMergeRequest$Type extends MessageType {
    constructor() {
        super("PermitListMergeRequest", [
            { no: 1, name: "kind", kind: "enum", T: () => ["PermitListKind", PermitListKind, "PERMIT_LIST_KIND_"] },
            { no: 2, name: "from_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "into_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.kind = 0;
        message.fromId = 0;
        message.intoId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* PermitListKind kind */ 1:
                    message.kind = reader.int32();
                    break;
                case /* int32 from_id */ 2:
                    message.fromId = reader.int32();
                    break;
                case /* int32 into_id */ 3:
                    message.intoId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* PermitListKind kind = 1; */
        if (message.kind !== 0)
            writer.tag(1, WireType.Varint).int32(message.kind);
        /* int32 from_id = 2; */
        if (message.fromId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fromId);
        /* int32 into_id = 3; */
        if (message.intoId !== 0)
            writer.tag(3, WireType.Varint).int32(message.intoId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitListMergeRequest
 */
export const PermitListMergeRequest = new PermitListMergeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitBlockerRequest$Type extends MessageType {
    constructor() {
        super("PermitBlockerRequest", [
            { no: 1, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "blocker_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.permitId = 0;
        message.blockerId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 permit_id */ 1:
                    message.permitId = reader.int32();
                    break;
                case /* int32 blocker_id */ 2:
                    message.blockerId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 permit_id = 1; */
        if (message.permitId !== 0)
            writer.tag(1, WireType.Varint).int32(message.permitId);
        /* int32 blocker_id = 2; */
        if (message.blockerId !== 0)
            writer.tag(2, WireType.Varint).int32(message.blockerId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitBlockerRequest
 */
export const PermitBlockerRequest = new PermitBlockerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitActivity$Type extends MessageType {
    constructor() {
        super("PermitActivity", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "activity_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "permit_group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "inspection_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "changes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "created_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "created_by_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "created_at", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "list_kind", kind: "enum", T: () => ["PermitListKind", PermitListKind, "PERMIT_LIST_KIND_"] },
            { no: 13, name: "list_item_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.activityTypeId = 0;
        message.permitGroupId = 0;
        message.permitId = 0;
        message.inspectionId = 0;
        message.changes = "";
        message.note = "";
        message.createdBy = 0;
        message.createdByName = "";
        message.createdAt = "";
        message.listKind = 0;
        message.listItemId = 0;
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 activity_type_id */ 2:
                    message.activityTypeId = reader.int32();
                    break;
                case /* int32 permit_group_id */ 4:
                    message.permitGroupId = reader.int32();
                    break;
                case /* int32 permit_id */ 5:
                    message.permitId = reader.int32();
                    break;
                case /* int32 inspection_id */ 6:
                    message.inspectionId = reader.int32();
                    break;
                case /* string changes */ 7:
                    message.changes = reader.string();
                    break;
                case /* string note */ 8:
                    message.note = reader.string();
                    break;
                case /* int32 created_by */ 9:
                    message.createdBy = reader.int32();
                    break;
                case /* string created_by_name */ 10:
                    message.createdByName = reader.string();
                    break;
                case /* string created_at */ 11:
                    message.createdAt = reader.string();
                    break;
                case /* PermitListKind list_kind */ 12:
                    message.listKind = reader.int32();
                    break;
                case /* int32 list_item_id */ 13:
                    message.listItemId = reader.int32();
                    break;
                case /* repeated string field_mask */ 14:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 15:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 16:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 17:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 18:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 activity_type_id = 2; */
        if (message.activityTypeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.activityTypeId);
        /* int32 permit_group_id = 4; */
        if (message.permitGroupId !== 0)
            writer.tag(4, WireType.Varint).int32(message.permitGroupId);
        /* int32 permit_id = 5; */
        if (message.permitId !== 0)
            writer.tag(5, WireType.Varint).int32(message.permitId);
        /* int32 inspection_id = 6; */
        if (message.inspectionId !== 0)
            writer.tag(6, WireType.Varint).int32(message.inspectionId);
        /* string changes = 7; */
        if (message.changes !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.changes);
        /* string note = 8; */
        if (message.note !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.note);
        /* int32 created_by = 9; */
        if (message.createdBy !== 0)
            writer.tag(9, WireType.Varint).int32(message.createdBy);
        /* string created_by_name = 10; */
        if (message.createdByName !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.createdByName);
        /* string created_at = 11; */
        if (message.createdAt !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.createdAt);
        /* PermitListKind list_kind = 12; */
        if (message.listKind !== 0)
            writer.tag(12, WireType.Varint).int32(message.listKind);
        /* int32 list_item_id = 13; */
        if (message.listItemId !== 0)
            writer.tag(13, WireType.Varint).int32(message.listItemId);
        /* repeated string field_mask = 14; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 15; */
        if (message.pageNumber !== 0)
            writer.tag(15, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 16; */
        if (message.orderBy !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 17; */
        if (message.orderDir !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 18; */
        if (message.withoutLimit !== false)
            writer.tag(18, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitActivity
 */
export const PermitActivity = new PermitActivity$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitActivityType$Type extends MessageType {
    constructor() {
        super("PermitActivityType", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.name = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* string name */ 2:
                    message.name = reader.string();
                    break;
                case /* repeated string field_mask */ 3:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 4:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 5:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* string name = 2; */
        if (message.name !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* repeated string field_mask = 3; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 4; */
        if (message.pageNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 5; */
        if (message.withoutLimit !== false)
            writer.tag(5, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitActivityType
 */
export const PermitActivityType = new PermitActivityType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitActivityTypeList$Type extends MessageType {
    constructor() {
        super("PermitActivityTypeList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitActivityType },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitActivityType results */ 1:
                    message.results.push(PermitActivityType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitActivityType results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitActivityType.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitActivityTypeList
 */
export const PermitActivityTypeList = new PermitActivityTypeList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitActivityList$Type extends MessageType {
    constructor() {
        super("PermitActivityList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitActivity },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitActivity results */ 1:
                    message.results.push(PermitActivity.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitActivity results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitActivity.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitActivityList
 */
export const PermitActivityList = new PermitActivityList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitNoteRequest$Type extends MessageType {
    constructor() {
        super("PermitNoteRequest", [
            { no: 1, name: "permit_group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "note", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.permitGroupId = 0;
        message.permitId = 0;
        message.note = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 permit_group_id */ 1:
                    message.permitGroupId = reader.int32();
                    break;
                case /* int32 permit_id */ 2:
                    message.permitId = reader.int32();
                    break;
                case /* string note */ 3:
                    message.note = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 permit_group_id = 1; */
        if (message.permitGroupId !== 0)
            writer.tag(1, WireType.Varint).int32(message.permitGroupId);
        /* int32 permit_id = 2; */
        if (message.permitId !== 0)
            writer.tag(2, WireType.Varint).int32(message.permitId);
        /* string note = 3; */
        if (message.note !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.note);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitNoteRequest
 */
export const PermitNoteRequest = new PermitNoteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitHandoffRecipient$Type extends MessageType {
    constructor() {
        super("PermitHandoffRecipient", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "department_group_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.departmentId = 0;
        message.departmentGroupId = 0;
        message.email = "";
        message.isActive = false;
        message.sortOrder = 0;
        message.departmentName = "";
        message.fieldMask = [];
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.withoutLimit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 department_id */ 2:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 department_group_id */ 3:
                    message.departmentGroupId = reader.int32();
                    break;
                case /* string email */ 4:
                    message.email = reader.string();
                    break;
                case /* bool is_active */ 5:
                    message.isActive = reader.bool();
                    break;
                case /* int32 sort_order */ 6:
                    message.sortOrder = reader.int32();
                    break;
                case /* string department_name */ 7:
                    message.departmentName = reader.string();
                    break;
                case /* repeated string field_mask */ 9:
                    message.fieldMask.push(reader.string());
                    break;
                case /* int32 page_number */ 10:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 11:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 12:
                    message.orderDir = reader.string();
                    break;
                case /* bool without_limit */ 13:
                    message.withoutLimit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 department_id = 2; */
        if (message.departmentId !== 0)
            writer.tag(2, WireType.Varint).int32(message.departmentId);
        /* int32 department_group_id = 3; */
        if (message.departmentGroupId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentGroupId);
        /* string email = 4; */
        if (message.email !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.email);
        /* bool is_active = 5; */
        if (message.isActive !== false)
            writer.tag(5, WireType.Varint).bool(message.isActive);
        /* int32 sort_order = 6; */
        if (message.sortOrder !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortOrder);
        /* string department_name = 7; */
        if (message.departmentName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.departmentName);
        /* repeated string field_mask = 9; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* int32 page_number = 10; */
        if (message.pageNumber !== 0)
            writer.tag(10, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 11; */
        if (message.orderBy !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 12; */
        if (message.orderDir !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderDir);
        /* bool without_limit = 13; */
        if (message.withoutLimit !== false)
            writer.tag(13, WireType.Varint).bool(message.withoutLimit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitHandoffRecipient
 */
export const PermitHandoffRecipient = new PermitHandoffRecipient$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitHandoffRecipientList$Type extends MessageType {
    constructor() {
        super("PermitHandoffRecipientList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PermitHandoffRecipient },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PermitHandoffRecipient results */ 1:
                    message.results.push(PermitHandoffRecipient.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PermitHandoffRecipient results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PermitHandoffRecipient.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitHandoffRecipientList
 */
export const PermitHandoffRecipientList = new PermitHandoffRecipientList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AdvancePermitStageRequest$Type extends MessageType {
    constructor() {
        super("AdvancePermitStageRequest", [
            { no: 1, name: "permit_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "target_status", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "permit", kind: "message", T: () => Permit },
            { no: 4, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "resolve_blocker_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "handoff", kind: "message", T: () => PermitStageHandoff }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.permitId = 0;
        message.targetStatus = 0;
        message.fieldMask = [];
        message.resolveBlockerIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 permit_id */ 1:
                    message.permitId = reader.int32();
                    break;
                case /* int32 target_status */ 2:
                    message.targetStatus = reader.int32();
                    break;
                case /* Permit permit */ 3:
                    message.permit = Permit.internalBinaryRead(reader, reader.uint32(), options, message.permit);
                    break;
                case /* repeated string field_mask */ 4:
                    message.fieldMask.push(reader.string());
                    break;
                case /* repeated int32 resolve_blocker_ids */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.resolveBlockerIds.push(reader.int32());
                    else
                        message.resolveBlockerIds.push(reader.int32());
                    break;
                case /* PermitStageHandoff handoff */ 6:
                    message.handoff = PermitStageHandoff.internalBinaryRead(reader, reader.uint32(), options, message.handoff);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 permit_id = 1; */
        if (message.permitId !== 0)
            writer.tag(1, WireType.Varint).int32(message.permitId);
        /* int32 target_status = 2; */
        if (message.targetStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.targetStatus);
        /* Permit permit = 3; */
        if (message.permit)
            Permit.internalBinaryWrite(message.permit, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated string field_mask = 4; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* repeated int32 resolve_blocker_ids = 5; */
        if (message.resolveBlockerIds.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.resolveBlockerIds.length; i++)
                writer.int32(message.resolveBlockerIds[i]);
            writer.join();
        }
        /* PermitStageHandoff handoff = 6; */
        if (message.handoff)
            PermitStageHandoff.internalBinaryWrite(message.handoff, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message AdvancePermitStageRequest
 */
export const AdvancePermitStageRequest = new AdvancePermitStageRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PermitStageHandoff$Type extends MessageType {
    constructor() {
        super("PermitStageHandoff", [
            { no: 1, name: "send", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "extra_recipients", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "skip_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.send = false;
        message.extraRecipients = [];
        message.skipReason = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool send */ 1:
                    message.send = reader.bool();
                    break;
                case /* repeated string extra_recipients */ 2:
                    message.extraRecipients.push(reader.string());
                    break;
                case /* string skip_reason */ 3:
                    message.skipReason = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool send = 1; */
        if (message.send !== false)
            writer.tag(1, WireType.Varint).bool(message.send);
        /* repeated string extra_recipients = 2; */
        for (let i = 0; i < message.extraRecipients.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.extraRecipients[i]);
        /* string skip_reason = 3; */
        if (message.skipReason !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.skipReason);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PermitStageHandoff
 */
export const PermitStageHandoff = new PermitStageHandoff$Type();
/**
 * @generated ServiceType for protobuf service PermitService
 */
export const PermitService = new ServiceType("PermitService", [
    { name: "GetPermitStatus", options: {}, I: PermitStatus, O: PermitStatus },
    { name: "BatchGetPermitStatus", options: {}, I: Empty, O: PermitStatusList },
    { name: "GetInspectionStatus", options: {}, I: InspectionStatus, O: InspectionStatus },
    { name: "BatchGetInspectionStatus", options: {}, I: Empty, O: InspectionStatusList },
    { name: "CreatePermitGroup", options: {}, I: PermitGroup, O: PermitGroup },
    { name: "GetPermitGroup", options: {}, I: PermitGroup, O: PermitGroup },
    { name: "BatchGetPermitGroup", options: {}, I: PermitGroup, O: PermitGroupList },
    { name: "UpdatePermitGroup", options: {}, I: PermitGroup, O: PermitGroup },
    { name: "DeletePermitGroup", options: {}, I: PermitGroup, O: Empty },
    { name: "CreatePermit", options: {}, I: Permit, O: Permit },
    { name: "GetPermit", options: {}, I: Permit, O: Permit },
    { name: "BatchGetPermit", options: {}, I: Permit, O: PermitList },
    { name: "UpdatePermit", options: {}, I: Permit, O: Permit },
    { name: "DeletePermit", options: {}, I: Permit, O: Empty },
    { name: "CreateInspection", options: {}, I: Inspection, O: Inspection },
    { name: "GetInspection", options: {}, I: Inspection, O: Inspection },
    { name: "BatchGetInspection", options: {}, I: Inspection, O: InspectionList },
    { name: "UpdateInspection", options: {}, I: Inspection, O: Inspection },
    { name: "DeleteInspection", options: {}, I: Inspection, O: Empty },
    { name: "GetPermitTrade", options: {}, I: PermitTrade, O: PermitTrade },
    { name: "BatchGetPermitTrade", options: {}, I: PermitTrade, O: PermitTradeList },
    { name: "CreatePermitDocument", options: {}, I: PermitDocument, O: PermitDocument },
    { name: "GetPermitDocument", options: {}, I: PermitDocument, O: PermitDocument },
    { name: "BatchGetPermitDocument", options: {}, I: PermitDocument, O: PermitDocumentList },
    { name: "UpdatePermitDocument", options: {}, I: PermitDocument, O: PermitDocument },
    { name: "DeletePermitDocument", options: {}, I: PermitDocument, O: Empty },
    { name: "CreatePermitGroupDocument", options: {}, I: PermitGroupDocument, O: PermitGroupDocument },
    { name: "GetPermitGroupDocument", options: {}, I: PermitGroupDocument, O: PermitGroupDocument },
    { name: "BatchGetPermitGroupDocument", options: {}, I: PermitGroupDocument, O: PermitGroupDocumentList },
    { name: "UpdatePermitGroupDocument", options: {}, I: PermitGroupDocument, O: PermitGroupDocument },
    { name: "DeletePermitGroupDocument", options: {}, I: PermitGroupDocument, O: Empty },
    { name: "AddPermitBlocker", options: {}, I: PermitBlockerRequest, O: Permit },
    { name: "RemovePermitBlocker", options: {}, I: PermitBlockerRequest, O: Permit },
    { name: "BatchGetPermitActivityType", options: {}, I: PermitActivityType, O: PermitActivityTypeList },
    { name: "BatchGetPermitActivity", options: {}, I: PermitActivity, O: PermitActivityList },
    { name: "CreatePermitNote", options: {}, I: PermitNoteRequest, O: PermitActivity },
    { name: "BatchGetPermitListItem", options: {}, I: PermitListItem, O: PermitListItemList },
    { name: "CreatePermitListItem", options: {}, I: PermitListItem, O: PermitListItem },
    { name: "RenamePermitListItem", options: {}, I: PermitListItem, O: PermitListItem },
    { name: "ReorderPermitListItems", options: {}, I: PermitListReorderRequest, O: PermitListItemList },
    { name: "RetirePermitListItem", options: {}, I: PermitListItem, O: PermitListItem },
    { name: "RestorePermitListItem", options: {}, I: PermitListItem, O: PermitListItem },
    { name: "MergePermitListItem", options: {}, I: PermitListMergeRequest, O: PermitListItem },
    { name: "BatchGetPermitHandoffRecipient", options: {}, I: PermitHandoffRecipient, O: PermitHandoffRecipientList },
    { name: "CreatePermitHandoffRecipient", options: {}, I: PermitHandoffRecipient, O: PermitHandoffRecipient },
    { name: "UpdatePermitHandoffRecipient", options: {}, I: PermitHandoffRecipient, O: PermitHandoffRecipient },
    { name: "RetirePermitHandoffRecipient", options: {}, I: PermitHandoffRecipient, O: PermitHandoffRecipient },
    { name: "RestorePermitHandoffRecipient", options: {}, I: PermitHandoffRecipient, O: PermitHandoffRecipient },
    { name: "RetryPermitHandoff", options: {}, I: PermitActivity, O: PermitActivity },
    { name: "AdvancePermitStage", options: {}, I: AdvancePermitStageRequest, O: Permit }
]);
